import { $$ } from '../utils/dom.js';
import { on } from '../utils/events.js';

export function initAccordion() {
  const roots = $$('[data-component="accordion"]');
  const disposers = roots.map((root) => setupAccordion(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setItemState(item, open, { animate = false } = {}) {
  const trigger = item.querySelector('[data-accordion-trigger]');
  const panelId = trigger?.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;

  if (!trigger || !panel) {
    return;
  }

  item.setAttribute('data-state', open ? 'open' : 'closed');
  trigger.setAttribute('aria-expanded', String(open));

  if (animate) {
    panel.setAttribute('aria-hidden', String(!open));
    panel.removeAttribute('hidden');
    return;
  }

  panel.removeAttribute('aria-hidden');

  if (open) {
    panel.removeAttribute('hidden');
  } else {
    panel.setAttribute('hidden', '');
  }
}

function setupAccordion(root) {
  const exclusive = root.hasAttribute('data-accordion-exclusive');
  const animate = root.hasAttribute('data-accordion-animate');
  const options = { animate };

  if (animate) {
    $$('[data-accordion-item]', root).forEach((item) => {
      const panelId = item.querySelector('[data-accordion-trigger]')?.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (panel) {
        panel.removeAttribute('hidden');
      }
    });
  }

  const toggleItem = (trigger) => {
    const item = trigger.closest('[data-accordion-item]');
    if (!item) {
      return;
    }

    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) {
      return;
    }

    const isOpen = item.getAttribute('data-state') === 'open';
    const nextOpen = !isOpen;

    if (exclusive && nextOpen) {
      $$('[data-accordion-item]', root).forEach((other) => {
        if (other !== item) {
          setItemState(other, false, options);
        }
      });
    }

    setItemState(item, nextOpen, options);
  };

  const removeClick = on(root, 'click', '[data-accordion-trigger], [data-accordion-toggle]', (event) => {
    event.preventDefault();

    let trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger) {
      const toggle = event.target.closest('[data-accordion-toggle]');
      trigger = toggle?.closest('[data-accordion-item]')?.querySelector('[data-accordion-trigger]') ?? null;
    }

    if (!trigger) {
      return;
    }

    toggleItem(trigger);
  });

  return () => {
    removeClick();
  };
}
